import React, { Component } from "react";
import { Container, Row, Col, Button, Form, FormGroup, Label, Input, Modal, ModalBody, DropdownItem, DropdownMenu, UncontrolledDropdown, DropdownToggle } from 'reactstrap';
import httpClient from "../../../httpClient";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faAngleDown, faAngleLeft, faAngleRight, faTimes,
} from '@fortawesome/free-solid-svg-icons'
import data from '../../data/data.json'
import { TextField, Box } from '@mui/material';
import { MobileDateRangePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { connect } from 'react-redux';
import { addVoyage, addTarifVoyage, addPhotoVoyage } from "../../../slices/modalSlice";


class AddVoyageAnnounce extends Component {
    constructor(props) {
        super(props);
        this.state = {
            announceVoyageInfo: { title: "", depart: "skikda", destination: "ouergla", date: [null, null], description: "", transport: "avion", type_hebergement: "Hotel", pension: "Demi-pension", nbrPlaces: 10, checkPlaces: false, tarification: [{ RoomType: "Single", TarifAdulte: Number, TarifEnfant: Number, devise: "DZD" }], condition: "", files: [], imagName: [] },
            categorie: "Voyage",
            imgUrl: [],
            alertMaxPic: false

        }
        this.toogleaddVoyage = this.toogleaddVoyage.bind(this)
        this.toogleaddTarifVoyage = this.toogleaddTarifVoyage.bind(this)
        this.tooglePhotos = this.tooglePhotos.bind(this)

    }
    componentDidUpdate(prevProps, prevState) {

    }

    postAnnounceVoyage(evt) {
        // evt.preventDefault();
        // let info = JSON.stringify(this.state.announceVoyageInfo);
        evt.preventDefault();
        const info = this.state.announceVoyageInfo;
        const idOwner = this.props.idOwner;
        const files = this.state.announceVoyageInfo.files
        alert(JSON.stringify(info))
        if (this.props.addPhotoVoyage == true) this.tooglePhotos()
    

    }
    toogleaddVoyage = () => this.props.dispatch(addVoyage())
    toogleaddTarifVoyage = () => this.props.dispatch(addTarifVoyage())
    tooglePhotos = () => this.props.dispatch(addPhotoVoyage())

    returnTarif = () => {
        if (this.props.addTarifVoyage == true) this.toogleaddTarifVoyage();
        if (this.props.addPhotoVoyage == true) this.tooglePhotos()
        if (this.props.addVoyage == false) this.toogleaddVoyage()

    }
    returnPhotos = () => {
        if (this.props.addTarifVoyage == false) this.toogleaddTarifVoyage();
        if (this.props.addPhotoVoyage == true) this.tooglePhotos()
        if (this.props.addVoyage == true) this.toogleaddVoyage()
    }

    onInputChange(evt) {
        evt.preventDefault();

        if (evt.target.type !== "checkbox") {
            this.setState({
                announceVoyageInfo: {
                    ...this.state.announceVoyageInfo,
                    [evt.target.name]: evt.target.value
                }
            })
        }
        else if (evt.target.type === "checkbox") {
            const value = evt.target.checked;
            this.setState({
                announceVoyageInfo: {
                    ...this.state.announceVoyageInfo,
                    checkPlaces: value
                }
            })
        }
    }
    onInputChangeTarif(evt, index) {
        // evt.preventDefault();
        // if (evt.target.type == "number") {
        //     this.setState({
        //         announceVoyageInfo: {
        //             ...this.state.announceVoyageInfo,
        //             tarification: { ...this.state.announceVoyageInfo.tarification, [evt.target.name]: evt.target.value }
        //         }
        //     })
        // }
        // else if (evt.target.type == "text") {
        //     this.setState({
        //         announceVoyageInfo: {
        //             ...this.state.announceVoyageInfo,
        //             [evt.target.name]: evt.target.value
        //         }
        //     })
        // }
        const values = [...this.state.announceVoyageInfo.tarification];
        if (evt.target.name === 'RoomType') {
            values[index].RoomType = evt.target.value;            
        } else if (evt.target.name === 'TarifAdulte' && evt.target.value > 0) {
            values[index].TarifAdulte = evt.target.value
        } else if (evt.target.name === 'TarifEnfant' && evt.target.value > 0) {
            values[index].TarifEnfant = evt.target.value
        } else if (evt.target.name === 'devise') {
            values[index].devise = evt.target.value
        }
        this.setState({
            announceVoyageInfo: {
                ...this.state.announceVoyageInfo,
                tarification: values
            }
        })
    }

    onChangeUpload(e) {
        if (this.state.imgUrl.length <= 4) {
            this.setState({ files: e.target.files[0] });
            e.preventDefault();

            const file = e.target.files[0]

            this.setState({
                announceVoyageInfo: {
                    ...this.state.announceVoyageInfo,
                    files: [...this.state.announceVoyageInfo.files, file]
                }
            })
            const fileReader = new FileReader();
            fileReader.onload = () => {
                this.setState({ imgUrl: [...this.state.imgUrl, fileReader.result] });
            }
            fileReader.readAsDataURL(file);
        }
        else (
            this.setState({
                alertMaxPic: true
            })
        )
    }

    getData_dropDown(e, item) {
        e.preventDefault()
        this.setState({
            announceVoyageInfo: {
                ...this.state.announceVoyageInfo,
                [e.currentTarget.name]: item || e.currentTarget.textContent
            }
        });
    }
    handleAddFields = () => {
        const values = [...this.state.announceVoyageInfo.tarification];
        values.push({ RoomType: 'RoomType', TarifAdulte: Number, TarifEnfant: Number, devise: "DZD" })
        this.setState({
            announceVoyageInfo: {
                ...this.state.announceVoyageInfo,
                tarification: values
            }
        });
    };
    handleRemoveFields = (evt, i) => {
        const values = [...this.state.announceVoyageInfo.tarification];
        if (values.length > 1) values.splice(i, 1);
        this.setState({
            announceVoyageInfo: {
                ...this.state.announceVoyageInfo,
                tarification: values
            }
        });
    };

    render() {
        const willayaDepart = data.wilayas.map(function (item, i) {
            return (
                <DropdownItem name="depart" onClick={e => this.getData_dropDown(e, item.name)}> <span>{i + 1}</span> {item.name}</DropdownItem>
            )
        }, this)
        const willayaDestination = data.wilayas.map(function (item, i) {
            return (
                <DropdownItem name="destination" onClick={e => this.getData_dropDown(e, item.name)}> <span>{i + 1}</span> {item.name}</DropdownItem>
            )
        }, this)
        let { title, depart, destination, description, date, transport, type_hebergement, pension, nbrPlaces, checkPlaces, tarification, condition } = this.state.announceVoyageInfo

        const imag0 = this.state.imgUrl[0]
        const imag1 = this.state.imgUrl[1]
        const imag2 = this.state.imgUrl[2]
        const imag3 = this.state.imgUrl[3]
        const imag4 = this.state.imgUrl[4]

        return (
            <>
                {/* modal travel details  */}
                <Modal isOpen={this.props.addVoyage} toggle={this.toogleaddVoyage} className="modal-width-details-announce modal-addvoyage " size="lg">
                    <nav className="nav-windows-addanounce">
                        <button className="close-heberg" onClick={this.toogleaddVoyage} >
                            <span><FontAwesomeIcon icon={faTimes} /></span>
                        </button>
                        <div className="title-announce" >
                            Nouvelle Annonce - Voyage
                        </div>
                    </nav>

                    <div className="path-heberg" style={{ width: "75%" }}>
                        <div className="item-path-hebrg" style={{ backgroundColor: "#182952" }}>

                            <div className="number-path" style={{ backgroundColor: "white" }}>
                                <span className="number-path-value" style={{ color: "#182952" }}>1</span>
                            </div>

                            <span className="name-path" style={{ color: "white" }}>
                                Détails
                                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

                            </span>

                        </div>

                        <div className="item-path-hebrg" >

                            <div className="number-path" >
                                <span className="number-path-value" >2</span>
                            </div>

                            <span className="name-path" >
                                Tarification
                                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

                            </span>

                        </div>

                        <div className="item-path-hebrg">

                            <div className="number-path">
                                <span className="number-path-value">3</span>
                            </div>

                            <span className="name-path text-left ">
                                Photos
                                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

                            </span>

                        </div>



                    </div>

                    <ModalBody className="" style={{ margin: " 2em", border: "5px solid #182952" }}>
                        <Container>
                            <div className="form__segment mb-4">
                                <div className=" mb-4">
                                    <h4 className="segment__head__txt" >Informations de Base</h4>
                                </div>
                                <div className="segment__content d-flex align-items-end mb-4">
                                    <Form onChange={this.onInputChange.bind(this)} onSubmit={this.postAnnounceVoyage.bind(this)}>

                                        <Row className="second-Row">
                                            {/* <Col sm="1" id="label-title-input"><label>Titre</label></Col>
                                            <Col sm="10" className="input-width"><Input type="text" name="title" placeholder="Donnez un titre a votre annonce" className="title-announce-input" value={this.state.title} required></Input></Col> */}
                                            <h5 id="label-title-input" >Titre</h5>
                                            <Input type="text" name="title" placeholder="Donnez un titre a votre annonce" className="title-announce-input" value={title} required></Input>
                                        </Row>
                                        <Row>
                                            <div className="d-flex mr-5">
                                                <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                                                    Point de départ
                                                    <DropdownToggle className="button-add-pays title-announce-input"
                                                        onClick={e => { this.getData_dropDown.bind(this)(e) }}
                                                    >
                                                        {depart}
                                                        ,Algerie
                                                        <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                                                    </DropdownToggle>
                                                    <DropdownMenu right style={{ maxHeight: "280px", overflowY: "scroll" }} className="full-width">
                                                        {willayaDepart}
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                                <UncontrolledDropdown nav className="col-3 mr-4 px-0">
                                                    Destionation
                                                    <DropdownToggle className="button-add-pays title-announce-input"
                                                        onClick={e => { this.getData_dropDown.bind(this)(e) }}
                                                    >
                                                        {destination}
                                                        ,Algerie
                                                        <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                                                    </DropdownToggle>
                                                    <DropdownMenu right style={{ maxHeight: "280px", overflowY: "scroll" }} className="full-width">
                                                        {willayaDestination}
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    {/*<DateRangePicker
                                                        startText="date de depart "
                                                        endText="date de retour"
                                                        value={this.state.value}
                                                        onChange={(newValue) => {
                                                            this.setState({ value: newValue });
                                                        }}
                                                        renderInput={(startProps, endProps) => (
                                                            <React.Fragment>
                                                                date de depart
                                                                <TextField {...startProps} />
                                                                date de sortie
                                                                <TextField {...endProps} />
                                                            </React.Fragment>
                                                        )}
                                                    />  */}
                                                    <MobileDateRangePicker
                                                        startText="date de depart "
                                                        endText="date de retour"
                                                        value={date}
                                                        onChange={(newValue) => {
                                                            this.setState({
                                                                announceVoyageInfo: {
                                                                    ...this.state.announceVoyageInfo,
                                                                    date: newValue
                                                                }
                                                            });
                                                        }}
                                                        renderInput={(startProps, endProps) => (
                                                            <React.Fragment style={{ margin: "20px" }}>
                                                                <div htmlFor="">Date de Depart
                                                                    <input style={{ height: "35px" }} ref={startProps.inputRef} {...startProps.inputProps} /></div>
                                                                <Box sx={{ mx: 1.5 }}>  </Box>
                                                                <div htmlFor=""> Date de Retour
                                                                    <input style={{ height: "35px" }} ref={endProps.inputRef} {...endProps.inputProps} /></div>
                                                            </React.Fragment>
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        </Row>
                                        <Row className="d-flex mt-4">
                                            <h6>Description </h6>
                                            <textarea name="description" value={description} placeholder="Decriver votre annonce" required="" class="text-area-descr form-control"></textarea>
                                        </Row>
                                        <Row className="d-flex mt-4">
                                            <UncontrolledDropdown nav className="col-lg-4 col-md-4 col-sm-4 col-4  pr-2 px-0">
                                                Moyen de Transport
                                                <DropdownToggle className="button-add-addvoyage">
                                                    Par {transport}
                                                    <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                                                </DropdownToggle>
                                                <DropdownMenu right style={{ maxHeight: "280px", overflowY: "scroll" }} className="full-width">
                                                    <DropdownItem name="transport" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Avion</DropdownItem>
                                                    <DropdownItem name="transport" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Bus</DropdownItem>
                                                    <DropdownItem name="transport" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Train</DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                            <UncontrolledDropdown nav className="col-lg-4 col-md-4 col-sm-4 col-4 px-1  px-0">
                                                Type d'hebergement
                                                <DropdownToggle className="button-add-addvoyage">
                                                    {type_hebergement}
                                                    <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                                                </DropdownToggle>
                                                <DropdownMenu style={{ maxHeight: "280px", overflowY: "scroll" }} right className="full-width">
                                                    <DropdownItem name="type_hebergement" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Hotel</DropdownItem>
                                                    <DropdownItem name="type_hebergement" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Baingalow</DropdownItem>
                                                    <DropdownItem name="type_hebergement" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Appartement</DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                            <UncontrolledDropdown nav className="col-lg-4 col-md-4 col-sm-4 col-4  pl-2 px-0">
                                                Pension
                                                <DropdownToggle className="button-add-addvoyage">
                                                    {pension}
                                                    <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                                                </DropdownToggle>
                                                <DropdownMenu right style={{ maxHeight: "280px", overflowY: "scroll" }} className="full-width">
                                                    <DropdownItem name="pension" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Demi-pension</DropdownItem>
                                                    <DropdownItem name="pension" onClick={e => { this.getData_dropDown.bind(this)(e) }}>pension complete</DropdownItem>
                                                    <DropdownItem name="pension" onClick={e => { this.getData_dropDown.bind(this)(e) }}>aucune</DropdownItem>

                                                </DropdownMenu>
                                            </UncontrolledDropdown>

                                        </Row>
                                        <Row className="d-flex mt-4">
                                            <Col className="col-lg-4 col-md-4 col-sm-4 col-4 px-0">
                                                <label>Places disponobles</label>
                                                <input type="number" min="1" defaultValue={nbrPlaces} className="number-input-announce" name="nbrPlaces" />
                                            </Col>
                                            <Col className=" col-lg-5 col-md-5 col-sm-5 col-5 px-0">
                                                <div class="check-box m-0 form-check-equipement form-check ">
                                                    <input type="checkbox" id="idcheck" name="checkPlaces" style={{ width: "20px", height: "20px" }} class="form-check-input mt-2" />
                                                    <label className="m-2" for="idcheck" >
                                                        Afficher le nombre de places restants
                                                    </label>

                                                </div>
                                            </Col>
                                        </Row>


                                        <div className="buttons-details-announces mt-4">
                                            <Button className=" button-add-moule retour-button"><FontAwesomeIcon id="arrow-retour" icon={faAngleLeft} />Retour</Button>
                                            <Button className=" button-add-moule suivant-button"
                                                type="submit"
                                                onMouseDown={() => {

                                                    this.toogleaddVoyage();
                                                    this.props.dispatch(addTarifVoyage());

                                                }}
                                            >Suivant<FontAwesomeIcon id="arrow-suivant" icon={faAngleRight} />
                                            </Button>
                                        </div>
                                    </Form>

                                </div>
                            </div>

                        </Container>
                    </ModalBody>
                </Modal>

                {/* modal travel coast  */}
                <Modal isOpen={this.props.addTarifVoyage} toggle={this.toogleaddTarifVoyage} className="modal-width-details-announce modal-addvoyage " size="lg">
                    <nav className="nav-windows-addanounce">
                        <button className="close-heberg" onClick={this.toogleaddTarifVoyage} >
                            <span><FontAwesomeIcon icon={faTimes} /></span>
                        </button>
                        <div className="title-announce" >
                            Nouvelle Annonce - Voyage
                        </div>
                    </nav>

                    <div className="path-heberg" style={{ width: "75%" }}>
                        <div className="item-path-hebrg" >

                            <div className="number-path" >
                                <span className="number-path-value" >1</span>
                            </div>

                            <span className="name-path" >
                                Détails
                                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

                            </span>

                        </div>

                        <div className="item-path-hebrg" style={{ backgroundColor: "#182952" }}>

                            <div className="number-path" style={{ backgroundColor: "white" }} >
                                <span className="number-path-value" style={{ color: "#182952" }}>2</span>
                            </div>

                            <span className="name-path" style={{ color: "white" }} >
                                Tarification
                                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

                            </span>

                        </div>

                        <div className="item-path-hebrg">

                            <div className="number-path">
                                <span className="number-path-value">3</span>
                            </div>

                            <span className="name-path text-left ">
                                Photos
                                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

                            </span>

                        </div>



                    </div>

                    <ModalBody className="" style={{ margin: " 2em", border: "5px solid #182952" }}>
                        <Container>
                            <div className="form__segment mb-4">
                                <div className=" mb-4">
                                    <h4 className="segment__head__txt" >Tarification</h4>
                                </div>
                                <Form onSubmit={this.postAnnounceVoyage.bind(this)} >

                                    {
                                        tarification.map((data, i) => {
                                            return (
                                                <Row className="my-3" key={i}>
                                                    <Col className="col-lg-3 col-md-3 col-sm-3 col-3 px-2 ">
                                                        <FormGroup className="w-100 button-add-announce">
                                                        <span className="">type de chambre</span>
                                                            <Input type="select" className="w-100" name="RoomType"  id="exampleSelect" onChange={e => this.onInputChangeTarif(e,i)}>
                                                                <option  value="Single">Single</option>
                                                                <option  value="double">Double</option>
                                                                <option  value="suite">suite</option>
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col className="col-lg-3 col-md-3 col-sm-3 col-3 px-2 ">
                                                        <span className="d-block ">Tarif</span>
                                                        <input width={"100%"} type="number" min="1" placeholder="**** ****,00" value={data.TarifAdulte} className="number-input-tarifVoyage" name="TarifAdulte" onChange={e => this.onInputChangeTarif(e, i)} required />
                                                    </Col>
                                                    <Col className="col-lg-2 col-md-2 col-sm-2 col-2 px-2 ">
                                                        <FormGroup className="w-100 button-add-announce">
                                                        <span className="">devise</span>
                                                            <Input type="select" className="w-100" name="devise"  id="exampleSelect" onChange={e => this.onInputChangeTarif(e,i)}>
                                                                <option  value="DZD">DZD</option>
                                                                <option  value="EUR">EUR</option>
                                                                <option  value="US">US</option>
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col className="col-lg-3 col-md-3 col-sm-3 col-3 px-2 ">
                                                        <span className="d-block">Prix Enfant</span>
                                                        <input width={"100%"} type="number" min="1" placeholder="**** ****,00" className="number-input-tarifVoyage" value={data.TarifEnfant} name="TarifEnfant" onChange={e => this.onInputChangeTarif(e, i)} />
                                                    </Col>
                                                    <Col className="col-lg-1 col-md-1 col-sm-1 col-1 px-2 ">

                                                    {i > 0 ?
                                                        <button className="btn pt-4 " onClick={evt => this.handleRemoveFields(evt, i)}>
                                                        <img src="/imgs/dash/MDI - close-thick.svg" className="mt-1 w-75" alt="" />
                                                        </button>
                                                        : null
                                                    }   
                                                    </Col>
                                                </Row>
                                            )
                                        })
                                    }

                                    <div className="text-center">
                                        <button className="btn" onClick={evt => this.handleAddFields()}>
                                            <img src="/imgs/dash/add_green.svg" alt="" />
                                        </button>
                                    </div>
                                    <Row className="my-3">
                                        <label className="my-auto"> Conditions d'Annulation</label>
                                        <Input type="text" name="condition" placeholder="condition d'annulation" className="ml-3 w-75" value={condition} ></Input>
                                    </Row>
                                    <Row className="mb-2">
                                        <div className="buttons-details-announces">
                                            <Button className=" button-add-moule retour-button"
                                                onMouseDown={() => {
                                                    this.returnTarif()
                                                }}><FontAwesomeIcon id="arrow-retour" icon={faAngleLeft} />Retour</Button>
                                            <Button className=" button-add-moule suivant-button"
                                                type="submit"
                                                onMouseDown={() => {

                                                    this.toogleaddTarifVoyage();
                                                    this.tooglePhotos();

                                                }}
                                            >Suivant<FontAwesomeIcon id="arrow-suivant" icon={faAngleRight} />
                                            </Button>
                                        </div>
                                    </Row>

                                </Form>

                            </div>

                        </Container>
                    </ModalBody>
                </Modal>

                {/* model travel images   */}
                <Modal isOpen={this.props.addPhotoVoyage} toggle={this.tooglePhotos} className="modal-width-images-announce">
                    <nav className="nav-windows-addanounce">
                        <button className="close-heberg" onClick={this.toogleCloseaddTarifVoyage} >
                            <span><FontAwesomeIcon icon={faTimes} /></span>
                        </button>
                        <div className="title-announce" >
                            Nouvelle Annonce - Voyage
                        </div>
                    </nav>

                    <div className="path-heberg" style={{ width: "75%" }}>
                        <div className="item-path-hebrg" >

                            <div className="number-path" >
                                <span className="number-path-value" >1</span>
                            </div>

                            <span className="name-path" >
                                Détails
                                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

                            </span>

                        </div>


                        <div className="item-path-hebrg">

                            <div className="number-path">
                                <span className="number-path-value">2</span>
                            </div>

                            <span className="name-path text-left ">
                                Tarification
                                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

                            </span>

                        </div>

                        <div className="item-path-hebrg" style={{ backgroundColor: "#182952" }}>

                            <div className="number-path" style={{ backgroundColor: "white" }} >
                                <span className="number-path-value" style={{ color: "#182952" }}>3</span>
                            </div>

                            <span className="name-path" style={{ color: "white" }} >
                                Photos
                                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />
                            </span>

                        </div>





                    </div>

                    <ModalBody style={{ marginTop: "100px" }}>
                        <Container>
                            <Row>
                                <Col md="7" style={{ paddingRight: "0px" }}>
                                    <div className="test" style={{ width: "100%", height: "400px" }}>
                                        {
                                            imag0 &&
                                            <>
                                                <img src={this.state.imgUrl[0]} className="img-add-ann" alt="" />
                                            </>
                                        }

                                        {
                                            !imag0 &&
                                            <>
                                                <img src="/imgs/announces/firstAnn.png" className="img-add-ann" alt="" />
                                            </>
                                        }

                                    </div>
                                </Col>

                                <Col md="5">

                                    <Row className="row-half-height">
                                        <Col sm="6" className="padding0 pdt">
                                            {
                                                imag1 &&
                                                <>
                                                    <img src={this.state.imgUrl[1]} className="img-add-ann-small" alt="" />
                                                </>
                                            }

                                            {
                                                !imag1 &&
                                                <>
                                                    <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt="" />
                                                </>
                                            }
                                        </Col>

                                        <Col sm="6" className="padding0 pdt">
                                            {
                                                imag2 &&
                                                <>
                                                    <img src={this.state.imgUrl[2]} className="img-add-ann-small" alt="" />
                                                </>
                                            }

                                            {
                                                !imag2 &&
                                                <>
                                                    <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt="" />
                                                </>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="row-half-height">
                                        <Col sm="6" className="last-child-image padding0 pdt">
                                            {
                                                imag3 &&
                                                <>
                                                    <img src={this.state.imgUrl[3]} className="img-add-ann-small" alt="" />
                                                </>
                                            }

                                            {
                                                !imag3 &&
                                                <>
                                                    <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt="" />
                                                </>
                                            }
                                        </Col>
                                        <Col sm="6" className="last-child-image padding0 pdt">
                                            {
                                                imag4 &&
                                                <>
                                                    <img src={this.state.imgUrl[4]} className="img-add-ann-small" alt="" />
                                                </>
                                            }

                                            {
                                                !imag4 &&
                                                <>
                                                    <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt="" />
                                                </>
                                            }                   </Col>
                                    </Row>

                                </Col>

                            </Row>

                            <center className="files-upload-btn">

                                <form enctype="multipart/form-data">

                                    <label for='upload-photo' className="button-add-moule add-imgs-button" > <span id="ajouter-text">Ajouter des photos</span></label>
                                    {this.state.imgUrl.length >= 5 && <p style={{ color: "red" }}>Max 5 photos</p>}
                                    <input type="file" name="myImage[]" id="upload-photo" disabled={this.state.imgUrl.length >= 5}
                                        onChange={this.onChangeUpload.bind(this)}
                                    />
                                    {/* <input type="text" name="imageUrl" placeholder="image url" /> */}

                                </form>
                            </center>

                            <br /> <br />
                            <h6 style={{ color: "rgb(119, 113, 113)" }}>Ps : Vous pouvez télecharger jusqu'a 4 photos a la fois ,sous formats JPEG,PNG,BMP ou TIFF</h6>
                            <Row>
                                <div className="buttons-add-announce-photos">
                                    <Button className=" button-add-moule retour-button"
                                        onMouseDown={() => {
                                            this.returnPhotos();
                                        }}><FontAwesomeIcon id="arrow-retour" />Retour</Button>
                                    <Button className=" button-add-moule suivant-button"
                                        // onClick={this.)}
                                        onClick={this.postAnnounceVoyage.bind(this)
                                        }
                                    >Valider<FontAwesomeIcon id="arrow-suivant" icon={faAngleRight} /></Button>
                                </div>
                            </Row>

                        </Container>
                    </ModalBody>
                </Modal>
            </>

        )
    }


}



function mapStateToProps(state) {
    return {

        addVoyage: state.modal.addVoyage,
        addTarifVoyage: state.modal.addTarifVoyage,
        addPhotoVoyage: state.modal.addPhotoVoyage



    }
}
//connect function INJECTS dispatch function as a prop!!
export default connect(mapStateToProps)(AddVoyageAnnounce);